import { render, staticRenderFns } from "./Ebook_reader.vue?vue&type=template&id=3ddaf3c0"
import script from "./Ebook_reader.vue?vue&type=script&lang=js"
export * from "./Ebook_reader.vue?vue&type=script&lang=js"
import style0 from "./Ebook_reader.vue?vue&type=style&index=0&id=3ddaf3c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports